import { html } from 'fxjs/es';
import { colorsWrapper } from './colors.js';
export const mainTemplate = ({ colors, color_code }) => {
  return html`
    <div class="main_wrapper mp_maker_colors_wrapper_style colors_wrapper">
      ${colorsWrapper({ colors, color_code })}
    </div>
  `;
};
